<template>
  <div>
    <div class="pageTitleController">
      <img src="@/assets/img/6.png" />
      <div class="marginLeft15">消息通知</div>
    </div>
    <Plan class="marginTop20">
      <el-tabs v-model="tabon" @tab-click="toggle" type="card">
        <el-tab-pane label="全部消息" name="1"></el-tab-pane>
        <el-tab-pane label="未读消息" name="2"></el-tab-pane>
        <el-tab-pane label="已读消息" name="3"></el-tab-pane>
      </el-tabs>
      <div>
        <el-table :data="newlist" style="width: 100%" @row-click="godetail">
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column prop="createtime" label="时间" width="180">
          </el-table-column>
        </el-table>
        <div style="text-align: right;" class="marginTop15">
          <el-pagination
            :page-size="15"
            background
            layout="prev, pager, next"
            :total="total1"
            :current-page.sync="currentpage"
            @current-change="pagechange"
          >
          </el-pagination>
        </div>
      </div>
    </Plan>
    <el-dialog
      :visible.sync="show1"
      :title="title1"
      width="500px"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :show-close="false"
    >
      <div class="box1" v-html="content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "@/plugins/axios.js";
import Plan from "@/components/Plan.vue";
export default {
  components: {
    Plan
  },
  data() {
    return {
      word: "",
      tabon: "1",
      unread: 0,
      newlist: [], // 新闻列表
      total1: 0,
      currentpage: 1,
      pagenum: 0,
      show1: false, // 模态框现视
      title1: "",
      content: "",
      loading: false
    };
  },
  mounted() {
    this.getlist(1);
  },
  methods: {
    // 切换tab
    toggle(nav) {
      this.tabon = nav.name;
      this.pagenum = 0;
      this.currentpage = 1;
      this.getlist();
    },
    // 获取列表页
    async getlist(page) {
      let status = null;
      if (this.tabon === "2") {
        status = "normal";
      } else if (this.tabon === "3") {
        status = "hidden";
      }
      this.loading = true;
      const v = await Api.getNewslist(this.$store.state.token, status, page);
      this.loading = false;
      this.newlist = v.lists.data;
      this.total1 = Number(v.lists.total);
      this.unread = Number(v.unread);
    },
    // 修改页面
    pagechange(val) {
      if (val > 1) {
        this.pagenum = val;
        this.getlist(val);
      } else {
        this.pagenum = 0;
        this.getlist();
      }
    },
    // 获取详情
    async godetail(row) {
      const id = row.id;
      this.loading = true;
      const v = await Api.getNewsdetail(this.$store.state.token, id);
      this.loading = false;
      this.content = v.content;
      this.title1 = v.title;
      this.show1 = true;
      this.getlist();
    },
    sure() {
      this.show1 = false;
    }
  }
};
</script>
<style lang="less" scoped></style>
